"use client";

import { Button } from "@/components/ui/button";
import { downloadExcelFile } from "@/lib/utils";
import { useScopedI18n } from "@/messages/client";
import { Table } from "@tanstack/react-table";
import { format } from "date-fns";
import { Download } from "lucide-react";
import toast from "react-hot-toast";
import useSWRMutation from "swr/mutation";

function pickPartNumberByIndex<T>(array: T[], indices: number[]) {
  if (indices.length === 0) return array;

  let result: T[] = [];

  indices.forEach((item) => {
    result.push(array[item]);
  });

  return result;
}

async function exportExcel(params: {
  columnList: string[];
  partNumberList: string[];
}) {
  return fetch(`${process.env.NEXT_PUBLIC_API_HOST}/product/select/export`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      columnList: params.columnList,
      partNumberList: params.partNumberList,
    }),
  }).then(async (res) => {
    if (res.headers.get("Content-Type")?.includes("application/json")) {
      return {
        errors: [
          {
            extensions: {
              code: "10000",
            },
            message: "导出失败",
          },
        ],
      };
    } else {
      return res.arrayBuffer();
    }
  });
}

export default function ExportBtn<T>(props: { table: Table<T> }) {
  const t = useScopedI18n("选型器");

  const column = props.table.getVisibleFlatColumns();

  const partNumber = props.table.options.data ?? [];

  const selectIndexs = Object.keys(props.table.getState().rowSelection).map(
    (item) => Number(item)
  );

  const columnList = column
    .filter((item) => item.id !== "images" && item.id !== "material_number")
    .map((item) => item.columnDef.header) as string[];

  const partNumberList = pickPartNumberByIndex(partNumber, selectIndexs)?.map(
    (item) => {
      const original = item as unknown as {
        material_number: string;
      };

      return original.material_number;
    }
  );

  const { trigger, isMutating } = useSWRMutation("exportExcel", async () => {
    const arrayBuffer = await exportExcel({ columnList, partNumberList });

    if (arrayBuffer instanceof ArrayBuffer) {
      downloadExcelFile(
        arrayBuffer,
        `selection-tool-parametrics-${format(
          new Date(),
          "yyyyMMddHHmmss"
        )}.xlsx`
      );

      return;
    } else {
      toast.error(arrayBuffer?.errors?.[0]?.message);

      return;
    }
  });

  return (
    <Button
      className="w-full space-x-2 rounded-md"
      loading={isMutating}
      onClick={() => {
        trigger();
      }}>
      <Download size={18} />
      <span>{t("导出Excel")}</span>
    </Button>
  );
}
